import { useState } from 'react';
import { useGameStore } from '@/state/gameStore';
import { SkillWebPanel } from '@/ui/components/SkillWebPanel';
import { AugmentPanel } from '@/ui/components/AugmentPanel';
import './TerminalScreen.css';

/**
 * Terminal screen — power-progression hub.
 *
 * After the P2.A.5 sunset the Decrypter network is gone (CD flows directly
 * into the Augment-Tree now), so the screen is two tabs:
 *  - Augments — primary stat-multiplier sink, 25 nodes across 5 branches
 *  - Skill-Web — legacy multi-ring progression, scheduled for sunset in
 *    P2.B (Aspekt-System) but kept active for the transition window.
 */

type Tab = 'augments' | 'skillweb';

export function TerminalScreen() {
  const player = useGameStore((s) => s.player);
  const [tab, setTab] = useState<Tab>('augments');

  if (!player) return null;

  const cdPool = player.corruptedData ?? 0;

  return (
    <div className="terminal-v2">
      <nav className="terminal-v2__tabs">
        <button
          className={`terminal-v2__tab ${tab === 'augments' ? 'terminal-v2__tab--active' : ''}`}
          onClick={() => setTab('augments')}
        >
          ✦ Augments
        </button>
        <button
          className={`terminal-v2__tab ${tab === 'skillweb' ? 'terminal-v2__tab--active' : ''}`}
          onClick={() => setTab('skillweb')}
        >
          ⚛ Skill-Web
        </button>
      </nav>

      <div className="terminal-v2__status">
        <div className="cd-pool-pill cd-pool-pill--ready">
          ⌬ {cdPool.toLocaleString('de-DE')} Corrupted Data
        </div>
      </div>

      <div className="terminal-v2__body">
        {tab === 'augments' && (
          <div className="terminal-v2__augments-wrap">
            <AugmentPanel />
          </div>
        )}
        {tab === 'skillweb' && (
          <div className="terminal-v2__skillweb-wrap">
            <SkillWebPanel />
          </div>
        )}
      </div>
    </div>
  );
}
